import { render } from "./defaultHotspot.vue?vue&type=template&id=3f1da1cc"
import script from "./defaultHotspot.vue?vue&type=script&lang=js"
export * from "./defaultHotspot.vue?vue&type=script&lang=js"

import "./defaultHotspot.vue?vue&type=style&index=0&id=3f1da1cc&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\siemens-ecdp-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__